module.exports = __webpack_public_path__ + "img/logo_gallagher.115df06b.png";